// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#444","menuActiveText":"#409EFF","subMenuActiveText":"#409EFF","menuBg":"#f9f9f9","menuHover":"#dfdfdf","subMenuBg":"#dfdfdf","subMenuHover":"#d1d1d1","sideBarWidth":"180px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 104